export const USAGE_DROP_FILTER_KEYS = {
  CUNSUMPTION_DROP: "cunsumptionDrop",
  FEATURE_DROP: "featureDrop",
  DAYS_SINCE_LAST_LOGIN: "daysSinceLastLogin",
};
